import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const Reveal = ({ children, delay = 0, className = "", innerClassName = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -8% 0px" });
  return (
    <span ref={ref} className={`block overflow-hidden pb-[0.14em] -mb-[0.14em] ${className}`}>
      <motion.span
        className={`block will-change-transform ${innerClassName}`}
        initial={{ clipPath: "inset(0% 0% 100% 0%)", y: 32, opacity: 0.01 }}
        animate={
          inView
            ? { clipPath: "inset(0% 0% -8% 0%)", y: 0, opacity: 1 }
            : { clipPath: "inset(0% 0% 100% 0%)", y: 32, opacity: 0.01 }
        }
        transition={{ duration: 1.05, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -10% 0px" });
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 36 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 36 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
